const onboarding = {
  account: '帳號',
  password: '密碼',
  login: '登入',
  logout: '登出',
  loginSuccess: '登入成功',
  logoutSuccess: '您已成功登出',
  plzLoginWithAccPwd: '請輸入帳號密碼登入',
  registerNewAccount: '註冊新帳號',
  register: '註冊',
  or: '或者',
  forgotPassword: '忘記密碼',
  plzInputEmail: '請輸入您的 Email',
  resetPasswordSent: '重置密碼的郵件已寄至您的郵箱，請參照 Email 裡的指示重置您的密碼',
  send: '送出',
  youHaveNewMessages: '您有新訊息',
  plzGotoAccountToSeeIt: '請至會員頁面查看',
  backToAccount: '返回會員資訊',
}

const discount = {
  joinAccount: '加入會員',
  loginAccount: '登入會員',
  nextTime: '下次再說',
  applyEvent: '參加活動',
  alreadyApplied: '您已經參加過了',
  startLottery: '開始抽獎',
  stopLottery: '停止',
  congratulation: '恭喜您!',
  findAccountCoupon: '您獲得了優惠券 %{amount} 元，您可至會員頁面查看',
  coupons: '優惠券',
  amount: '金額',
  couponCode: '優惠碼',
  activatedPeriod: '有效期限',
  expireOn: '有效期限至 %{date}',
  used: '已使用?',
  ntd: '元',
  shareToFB: '分享到臉書',
  useCoupon: '使用優惠券',
  useCouponDiscount: '使用優惠券折抵 %{amount} 元',
  inputCouponCode: '輸入優惠碼',
}

const scene = {
  species: '生物種類',
  terrain: '地形景觀',
  bestSeason: '最佳季節',
  search: '搜尋',
  showAED: '顯示AED',
  hideAED: '隱藏AED',
  position: '位置',
}

const account = {
  edit: '修改',
  changePassword: '修改密碼',
  saveChanges: '儲存變更',
  cancel: '取消',
  accountInfo: '會員資料',
  yourOrder: '您的預訂',
  yourFavorite: '您的收藏',
  yourMessage: '您的訊息',
  id: '身份證',
  passport: '護照',
  idOrPassport: '身份證或護照號碼',
  invalidNumber: '不合法的號碼',
  realName: '真實姓名',
  displayName: '顯示名稱',
  firstName: '名字',
  lastName: '姓氏',
  name: '姓名',
  confirmPassword: '確認密碼',
  gender: '性別',
  birthday: '生日',
  contactPhone: '聯絡電話',
  email: 'E-Mail',
  updateAccountSuccess: '會員資料更新成功',
  back: '回上頁',
  allMessages: '所有訊息',
  orderMessages: '訂單訊息',
  activityQuestions: '活動訊問',
  systemNotification: '系統通知',
  subject: '主題',
  view: '查看',
  sender: '發送者',
  you: '你',
  shop: '店家',
  close: '關閉',
}

const traffic = {
  trafficInfo: '交通資訊',
  howToArrive: '如何到%{location}?',
  AIR: '航空',
  RAILWAY: '鐵路',
  CAR: '開車',
  SHIP: '客船',
  RELATED: '相關資訊',
}

const activity = {
  noSuitableResult: '無符合條件的結果',
  activity: '活動',
  date: '日期',
  persons: '人數',
  addons: '加購項目',
  charge: '費用',
  coastDiving: '岸潛',
  boatDiving: '船潛',
  highOxygenDiving: '高氧',
  divingServices: '潛水服務項目',
  experincingDiving: '體驗潛水',
  licenseDiving: '證照教學',
  funDiving: 'Fun Dive',
  otherServices: '其他服務',
  resident: '住宿',
  shuttle: '交通接駁',
  languageSupport: '中英服務',
  freeWifi: '免費WIFI',
  hotShower: '熱水淋浴間',
  seePrice: '查看價錢',
  record360: '360紀錄',
  lastFor: '活動時間',
  minute: '分鐘',
  hour: '小時',
  day: '天',
  chooseTimeSection: '請選擇梯次',
  assemblyPlace: '集合地點',
  seeDetail: '查看詳情',
  activityIntro: '活動簡介',
  activityFlow: '活動流程',
  activityContents: '活動包含',
  courseStructure: '課程結構',
  activityLimitations: '參加條件',
  pricePackages: '價格方案',
  activityNotices: '活動注意事項',
  cancelRules: '取消規定',
  addFavoriteSuccess: '加入最愛成功',
  removeFavoriteSuccess: '取消最愛成功',
  divingLicense: '潛水執照',
  divingExperience: '潛水經驗',
  addToFavorite: '加入收藏',
  removeFavorite: '取消收藏',
  writeComment: '發表評論',
  yourComment: '您的評論',
  whole: '整體',
  profession: '專業',
  service: '服務',
  comfort: '舒適',
  value: '價值',
  title: '標題',
  rating: '評分',
  sendComment: '送出評論',
  sendCommentSuccss: '評論送出成功',
  theComments: '評論',
  comments: '則評論',
  creator: '評論者',
  createdTime: '評論時間',
  activityName: '活動項目',
  content: '內容',
  price: '價格',
  minDivingExperience: '最低潛水經驗',
  orderNow: '馬上預訂',
  askActivity: '詢問活動',
  addShopToFavorite: '將店家加入收藏',
  removeShopFromFavorite: '將店家移出收藏',
  message: '訊息',
  sendMessageSuccess: '訊息發送成功',
  sendMessageFailure: '訊息發送失敗',
  none: '無',
  oneTime: '1-10 次',
  decadeTimes: '11-50 次',
  fiftyTimes: '51-100 次',
  hundredTimes: '100 次以上',
  activity_coming_soon: '活動即將推出',
  booked: '已預訂',
  requireTimeSection: '活動梯次未選擇',
  plzSelectTimeSection: '您尚未選擇活動梯次，請選擇欲預訂的梯次',
  not_business_day: '您選擇的日期非營業時間',
}

const shop = {
  intro: '簡介',
  address: '地址',
  certSystem: '證照系統',
  businessHours: '營業時間',
  detail: '詳細內容',
  setup: '%{year}年成立',
  others: '其他',
  // Diving Services
  discoverScubaDiving: '體驗潛水',
  diveCourse: '證照教學',
  freeDiving: '自由潛水',
  techDiving: '技術潛水',
  childrenDiving: '兒童潛水',
  shoreDive: '岸潛',
  boatDive: '船潛',
  nitrox: '高氧',
  professionalPhotographyDiveGuide: '職業攝影導遊',
  equipmentRental: '裝備租借',
  underwaterCameraRental: '水中攝影器材租借',
  diverPropulsionVehicleRental: '水中推進器租借',
  underwaterPhotographyService: '水中攝影紀錄',
  // Other Services
  accommodations: '住宿',
  chineseService: '中文服務',
  englishService: '英文服務',
  freeWifi: '免費wifi',
  hotShower: '熱水淋浴間',
  ferryTicketBooking: '代訂船票',
  motorcycleRental: '機車租借',
  bicycleRental: '腳踏車租借',
  dining: '餐點供應',
  snorkelling: '浮潛',
  nightFishing: '夜釣',
  ecoTours: '生態導覽',
  intertidalZoneNightTourUnchartedSpotExploration: '夜間潮間帶/秘境探索',
}

const order = {
  time: '時間',
  orderDate: '預訂日期',
  orderPersons: '預訂人數',
  people: '人',
  order: '預訂',
  plzLoginFirst: '請先登入會員',
  orderSuccess: '預訂成功',
  orderNo: '訂單編號',
  orderDetail: '訂單內容',
  cannotSelectPast: '無法選取過去的時間',
  noActivitySelected: '無可參與的活動，請選取有活動的時間',
  cancelOrder: '取消訂單',
  reOrder: '再次預訂',
  traveler: '遊客',
  travelerInfo: '遊客資料',
  travelInsurance: '*本次活動將投保旅遊平安險，請提供遊客資料',
  sameAsCreator: '同預訂人資料',
  yourInfo: '您的資訊',
  phone: '電話',
  creditCardInfo: '信用卡資訊',
  creditCardInfoComment: '*若選擇現場付款並不會馬上收取費用，僅供確認預訂使用',
  cardType: '卡片種類',
  cardNo: '卡號',
  validThru: '有效日期',
  securityCode: '安全碼',
  orderCancelNotice: '取消預定費用：＊如因天候海況等非人為因素不在此限',
  createOrderFailed: '建立訂單失敗',
  maxPeopleExceed: '此梯次名額已額滿，請選取其他梯次',
  confirmOrderPayArrived: '確認預訂',
  confirmOrderPayOnline: '確認預訂，線上付款',
  payNow: '立即付款',
  orderSuccessResult: '訂單尚需店家確認後才會正式成立。您的訂單編號為 %{orderNo}，您可以在 %{urOrders} 裡查看狀態',
  confirmCancelOrder: '確認要取消訂單？',
  cancelOrderResult: '訂單 %{orderNo} 已取消, 歡迎再次預訂',
  cancelOrderSuccess: '訂單取消成功',
  unavailable: '尚未啟用',
  paymentNotAvailable: '線上付款功能尚未啟用，敬請期待',
  plzCompleteTravelerInfo: '請輸入完整的旅客資料',
  incompleteData: '資料不完整',
  plzCompleteContactInfo: '請輸入完整的聯絡資訊',
  unconfirm: '待確認',
  confirmed: '已確認',
  unpaid: '未付款',
  paid: '已付款',
  cancelled: '已取消',
  orderConfirm: '訂單確認',
  confirmOrder: '確認訂單',
  inputEmailToConfrim: '輸入Email以確認',
  incorrectEmail: 'Email 不正確',
  confirmOrderFailed: '確認訂單失敗',
  confirmOrderSuccess: '確認訂單成功',
  confirmOrderResult: '訂單 %{orderNo} 確認成功',
  orderCancel: '訂單取消',
  cancelOrderFailed: '取消訂單失敗',
  // cancelOrderSuccess: '取消訂單成功',
  // cancelOrderResult: '訂單 %{orderNo} 取消成功',
  accountsPayable: '訂單總金額',
  contactInfo: '聯絡資訊',
}

const cht = {
  ...onboarding,
  ...discount,
  ...scene,
  ...account,
  ...traffic,
  ...activity,
  ...shop,
  ...order,
  about: '關於我們',
  searchPlaceholder: '地點：綠島、蘭嶼...',
  currency: '幣別',
  language: '語言',
  home360: '360導覽',
  homeRecent: '最新360',
  homeRecommend: '推薦活動',
  sortByHot: '按熱門程度排序',
  sortByUpdate: '按更新時間排序',
  homeInput: '今天想去哪潛水？',
  findActivity: '找活動',
  findActivityAround: '尋找附近的活動',
  find360Around: '查看附近360',
  findShopAround: '查看附近店家',
  goMap: '查看地圖',
  divingDifficulty: '潛水難度',
  divingMethod: '潛水方式',
  yourSearch: '您的搜尋',
  filter: '篩選項目',
  sortType: '排序方式',
  hotLevel: '熱門程度',
  customerRecommendation: '顧客評分',
  changeLocation: '換地方',
  difficulty: '難度等級',
  hard: '困難',
  medium: '中等',
  easy: '簡單',
  type: '方式',
  have: '有',
  haveNone: '沒有',
  terms: '服務條款',
  privacy: '隱私權政策',
  contact_support: '客服',
  yes: '是',
  no: '否',
}

export default cht


// WEBPACK FOOTER //
// ./src/i18n/cht.js